import React from 'react';

import { AppMenu, AppMenuItem } from '../menu/primitives';

/**
 * The overflow menu behind a card's ⋮ button.
 *
 * Returns `open`, the click handler to hang on the button, and `menu`, the
 * element to render inside the card.
 *
 * An option's `action` runs on the way out. A card's handlers never have to
 * close the menu themselves.
 */
export default function useCardMenu(menuOptions) {
  const [menuAnchor, setMenuAnchor] = React.useState(null);

  const open = (event) => setMenuAnchor(event.currentTarget);

  const close = (option) => {
    if (option && option.action) {
      option.action();
    }
    setMenuAnchor(null);
  };

  const menu = (
    <AppMenu
      anchorEl={menuAnchor}
      id="more-menu"
      open={Boolean(menuAnchor)}
      keepMounted
      onClose={close}
    >
      {menuOptions.map((option) => (
        <AppMenuItem
          key={option.id}
          onClick={() => close(option)}
        >
          {option.label}
        </AppMenuItem>
      ))}
    </AppMenu>
  );

  return { open, menu };
}
